/* myHarry Musterbox (Teil-Skript, global) */

  var CFG = window.MUSTERBOX_CONFIG || {};
  var MAX = parseInt(CFG.max, 10) || 5;
  var KEY = 'myharry_musterbox_v2';
  var LABEL_ADD = CFG.labelAdd || 'Muster auswählen';
  var LABEL_SEL = CFG.labelSelected || 'Muster gewählt';
  var SAMPLES = window.MUSTERBOX_SAMPLES || {};
  var PDP = window.MUSTERBOX_PDP || null;

  // Ausgeschlossene Produkte: Testpaket Balkenlager / Stelzlager (kein Badge, kein PDP-Hook)
  var EXCLUDE = { '7318904897695': 1, '7318911582367': 1 };
  (CFG.exclude || []).forEach(function (x) { EXCLUDE[String(x)] = 1; });

  // Ansprechpartner-Block (Modal) – aus Theme-Editor-Einstellungen
  var CONTACT = CFG.contact || {};
  var HEADER_ICON_URL = 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/shopping-cart-heart.png?v=1782829713';
  var CONTACT_IMG_DEFAULT = 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/Dominik_sitz.png?v=1763104155';
  // Vorteile-Block (Icons wie auf /collections/kostenlose-muster)
  var BENEFITS = [
    { icon: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/icon_shipping-fast.png?v=1782891152', text: 'Kostenlose Muster bequem nach Hause – Optik live erleben' },
    { icon: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/icon_variants.png?v=1782891152', text: 'Farbe und Maserung bei deinem Licht zu Hause beurteilen' },
    { icon: 'https://cdn.shopify.com/s/files/1/0335/0908/1133/files/icon_feel.png?v=1782891152', text: 'Material und Haptik anfassen, bevor du dich entscheidest' }
  ];

  // Bekannte Muster-Varianten (für Warenkorb-Abgleich)
  var SAMPLE_VARIANTS = {};
  Object.keys(SAMPLES).forEach(function (k) { if (SAMPLES[k] && SAMPLES[k].v) SAMPLE_VARIANTS[String(SAMPLES[k].v)] = 1; });
  if (PDP && PDP.v) SAMPLE_VARIANTS[String(PDP.v)] = 1;

  // ---- Store (Array von {id, v, img}) ----
  function load() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(selected)); } catch (e) {} }
  var selected = load();

  function indexOf(id) {
    id = String(id);
    for (var i = 0; i < selected.length; i++) { if (String(selected[i].id) === id) return i; }
    return -1;
  }
  function has(id) { return indexOf(id) !== -1; }
  function count() { return selected.length; }

  function add(item) {
    if (has(item.id)) return true;
    if (count() >= MAX) return false;
    selected.push(item); save();
    return true;
  }
  function removeId(id) {
    var i = indexOf(id); if (i === -1) return;
    selected.splice(i, 1); save();
  }

  function sampleFor(id, domImg) {
    var s = SAMPLES[String(id)];
    var isPdp = PDP && String(PDP.id) === String(id);
    var v = s && s.v ? s.v : (isPdp && PDP.v ? PDP.v : null);
    var img = s && s.img ? s.img : (isPdp && PDP.img ? PDP.img : null);
    var name = s && s.name ? s.name : (isPdp && PDP.name ? PDP.name : null);
    var label = s && s.label ? s.label : (isPdp && PDP.label ? PDP.label : null);
    if (!img) img = domImg || null;
    return { id: String(id), v: v, img: img, name: name, label: label };
  }

  // ---- Warenkorb (Sammel-Add) ----
  // /cart/update.js SETZT die Menge je Variante auf genau 1 (kein Aufaddieren bei
  // mehrfachem Klick). Zusammen mit dem 5er-Limit der Auswahl: max. 5 Muster, je 1 Stk.
  function addAllToCart() {
    var wanted = [], seen = {}, n = 0;
    for (var i = 0; i < selected.length; i++) {
      var v = selected[i].v;
      if (v && !seen[v] && n < MAX) { seen[v] = 1; wanted.push(String(v)); n++; }
    }
    if (!wanted.length) { toast('Keine bestellbaren Muster ausgewählt.'); return; }
    var btn = trayEl && trayEl.querySelector('.muster-tray__cta');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
    var H = { 'Content-Type': 'application/json' };
    // Warenkorb exakt auf die Auswahl abgleichen: alte Muster raus, gewählte (max. MAX) rein, je 1 Stk.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var clears = {};
        (cart.items || []).forEach(function (it) {
          var vid = String(it.variant_id || it.id);
          var marked = it.properties && (it.properties._muster || it.properties['_muster']);
          if (marked || SAMPLE_VARIANTS[vid]) clears[vid] = 0;
        });
        wanted.forEach(function (v) { clears[v] = 0; });
        var hasClears = Object.keys(clears).length > 0;
        var step = hasClears
          ? fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: clears }) })
          : Promise.resolve();
        return step.then(function () {
          var items = wanted.map(function (v) { return { id: Number(v), quantity: 1, properties: { _muster: '1' } }; });
          return fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: items }) });
        });
      })
      .then(function () {
        traySig = null; renderTray(); // Button zurücksetzen
        closeModal();
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        openCartDrawer();
      })
      .catch(function () {
        toast('Fehler beim Hinzufügen.');
        traySig = null; renderTray();
      });
  }

  // Öffnet den seitlichen Vorschau-Warenkorb (Cart-Drawer) und lädt ihn neu.
  function openCartDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.onCartRefresh === 'function') {
      var p;
      try { p = cd.onCartRefresh(); } catch (e) {}
      if (p && typeof p.then === 'function') {
        p.then(function () { try { cd.show(); } catch (e) {} });
      } else {
        try { cd.show(); } catch (e) {}
      }
    } else if (cd && typeof cd.show === 'function') {
      try { cd.show(); } catch (e) {}
    } else {
      window.location.href = '/cart';
    }
  }

  // ---- Toast ----
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'muster-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  // ---- Tray oben rechts (rendert nur bei echter Änderung -> kein Flackern) ----
  var trayEl, traySig = null;
  function positionTray() {
    if (!trayEl) return;
    // Mobile: CSS (unten) übernehmen
    if (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) { trayEl.style.top = ''; return; }
    var h = document.querySelector('#shopify-section-header, .section-header, .header-wrapper, header, .header, .site-header');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    trayEl.style.top = (b > 0 ? (b + 12) : 16) + 'px';
  }
  var trayClosed = false;
  function isDrawerOpen() {
    var cd = document.querySelector('cart-drawer');
    return !!(cd && (cd.hasAttribute('open') || cd.classList.contains('active') || cd.classList.contains('animate')));
  }
  // Sichtbarkeit: nur wenn Auswahl > 0, nicht manuell geschlossen, und Warenkorb-Drawer zu.
  function applyTrayVisibility() {
    if (!trayEl) return;
    var visible = count() > 0 && !trayClosed && !isDrawerOpen();
    trayEl.classList.toggle('is-visible', visible);
    updateReopen();
  }
  function renderTray() {
    if (!trayEl) {
      trayEl = document.createElement('div');
      trayEl.className = 'muster-tray';
      document.body.appendChild(trayEl);
    }
    positionTray();
    var n = count();
    var sig = n + '|' + selected.map(function (it) { return it.id + (it.v ? 'v' : ''); }).join(',');
    if (sig === traySig) { applyTrayVisibility(); return; }
    traySig = sig;

    var addable = 0, seen = {};
    for (var k = 0; k < selected.length; k++) { var vv = selected[k].v; if (vv && !seen[vv]) { seen[vv] = 1; addable++; } }

    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var it = selected[i];
      if (it) {
        slots += '<button type="button" class="muster-tray__slot is-filled" data-muster-id="' + it.id + '" aria-label="Muster entfernen">' +
          (it.img ? '<img src="' + it.img + '" alt="">' : '') + '</button>';
      } else {
        slots += '<span class="muster-tray__slot"></span>';
      }
    }
    var rest = MAX - n;
    var ctaLabel = 'In den Warenkorb' + (addable > 0 ? ' (' + addable + ')' : '');
    trayEl.innerHTML =
      '<div class="muster-tray__head"><span class="muster-tray__title">Deine Muster</span>' +
      '<div class="muster-tray__head-right">' +
      '<button type="button" class="muster-tray__close" aria-label="Schließen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
      '<span class="muster-tray__count">' + n + ' / ' + MAX + '</span></div></div>' +
      '<div class="muster-tray__slots">' + slots + '</div>' +
      '<div class="muster-tray__hint">' + (rest > 0 ? ('Noch ' + rest + ' Muster möglich') : 'Maximum erreicht') + '</div>' +
      '<button type="button" class="muster-tray__cta"' + (addable > 0 ? '' : ' disabled') + '>' + ctaLabel + '</button>';
    applyTrayVisibility();

    Array.prototype.forEach.call(trayEl.querySelectorAll('.muster-tray__slot.is-filled'), function (s) {
      s.addEventListener('click', function () { removeId(s.getAttribute('data-muster-id')); syncAll(); });
    });
    var cta = trayEl.querySelector('.muster-tray__cta');
    if (cta) cta.addEventListener('click', addAllToCart);
    var closeBtn = trayEl.querySelector('.muster-tray__close');
    if (closeBtn) closeBtn.addEventListener('click', function () { trayClosed = true; applyTrayVisibility(); });
  }

  // ---- Badge ----
  function syncBadge(b) {
    var id = b.getAttribute('data-muster-id');
    var on = has(id);
    b.classList.toggle('is-selected', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = b.querySelector('.muster-badge__label');
    if (label) label.textContent = on ? LABEL_SEL : LABEL_ADD;
  }

  function makeBadge(id, domImg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'muster-badge';
    b.setAttribute('data-muster-id', String(id));
    if (domImg) b.setAttribute('data-muster-img', domImg);
    b.innerHTML =
      '<svg class="muster-badge__plus" viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
      '<svg class="muster-badge__check" viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M4.5 10.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="muster-badge__label"></span>';
    syncBadge(b);
    b.addEventListener('click', onBadgeClick);
    return b;
  }
